<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>

      <v-layout row wrap>
        <v-flex xs12 sm5>
          <v-select
            v-model="selectSupplier"
            :items="suppliers"
            label="取引先選択"
            item-text="supplierName"
            item-value="supplierCode"
            :sort-by="['supplierCode']"
            :sort-desc="[false]"
            return-object
          ></v-select>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="stores"
        item-key="storeCode"
        class="elevation-1"
        hide-actions
        :customFilter="customFilter"
        :search="selectSupplier"
        :loading="loadingData"
        :custom-sort="customSort"
      >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.header.text }}</span>
            </template>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>

        <tr @click="forwardStoreEdit(props.item)">

        </tr>
        <template v-slot:items="props">
          <tr  
            v-if="dispDeleted === 'info' || (dispDeleted !== 'info' && '0' === props.item.isDeleted)"
            v-bind:class="{
              'deleted-class-name': props.item.isDeleted == '1' ? true : false,
              'changed-class-name': props.item.isChanged
            }" 
          >
            <td class="text-xs-left" style="width: 30px;" >
              <v-checkbox 
                v-model="props.item.isChecked" 
                primary 
                hide-details 
                @change="storeCheck(props.item)">
              </v-checkbox>
            </td>
            <td @click="forwardStoreDspDetail(props.item)" class="text-xs-left">{{ props.item.storeCode }}</td>
            <td @click="forwardStoreDspDetail(props.item)" class="text-xs-left">{{ props.item.storeName }}</td>
            <td @click="forwardStoreDspDetail(props.item)" class="text-xs-left">{{ props.item.supplierCode }}</td>
          </tr>
        </template>
      </v-data-table>
      <br />

      <!-- 버튼 영역 -->
      <div class="footer-btns">
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>Home
        </v-btn>
        <v-btn block class="ma-2" color="success" @click="forwardStoreItemDisplayRegist()" >
          <v-icon dark left>save</v-icon>非表示に登録する
        </v-btn>
        <v-btn block class="ma-2" color="red" @click="forwardStoreItemDisplayDelete()" >
          <v-icon dark left>save</v-icon>表示のため削除する
        </v-btn>      
      </div>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'

export default {
  created() {
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    this.loadingData = true

    // 모든 거래처 정보 가져오기
    ServerApiCallService.suppliers()
      .then(response => {
        this.suppliers = response.data.suppliers

        // 리스트 박스에 추가
        this.suppliers.unshift({
          supplierCode: '#',
          supplierName: '全て(使える店舗)'
        })
        
        this.suppliers.splice(1,0,{
          supplierCode: 'r',
          supplierName: '使えない店舗'
        })
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      }
    )

    // 모든 점포정보 가져오기
    ServerApiCallService.stores()
      .then(response => {
        // sort        
        this.stores = (response.data.stores || []).map(it => ({
          ...it,
          isChecked: false,
        }))

        this.loadingData = false
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })

  },
  methods: {
    customSort(items) {
      return [...items].sort((a, b) => {
        if (a.storeCode < b.storeCode) return -1
        if (a.storeCode > b.storeCode) return 1
        if (a.storeName < b.storeName) return -1
        if (a.storeName > b.storeName) return 1
        return 0
      })
    },
    customFilter(items, search) {
      if (search.supplierName === '全て(使える店舗)') {
        
        return this.customSort(items)
      } else {
        let filteringItems = items.filter(function(value) {
          // 선택된 거래처의 사용하는 점포만 보여주기
          if (value.supplierCode === search.supplierCode && value.isDeleted === '0') {
            return true
          } else {
            return false
          }
        })        

        return this.customSort(filteringItems)
      }
    },
    storeCheck(storeInfo) {
      // isChecked는 v-model이 이미 바꿔줌 (@change 시점)
      const code = storeInfo.storeCode;

      // 체크된 상태 → 선택 배열에 추가
      if (storeInfo.isChecked) {
        // 선택 추가 (중복 방지)
        if (!this.selectedStores.some(x => x.storeCode === code)) {
          this.selectedStores.push(storeInfo);
        }
      } else {
        // 체크 해제 → 선택 배열에서 제거
        this.selectedStores = this.selectedStores.filter(x => x.storeCode !== code);
      }
    },
    forwardStoreDspDetail(storeRow) {
      let forwardName = 'admin/display-store-items-detail2'
      this.$router.push({
        name: forwardName,
        params: {
          storeCode: storeRow.storeCode
        }
      })
    },    
    forwardStoreItemDisplayRegist() {
      // 점포를 선택하지 않았을때
      if (this.selectedStores.length === 0) {        
        this.$parent.$parent.$parent.showErrorDialog(
          '店舗を選択してください'
        )
        return
      }

      // 선택한 점포를 sesseion에 등록
      sessionStorage.setItem("param", JSON.stringify(this.selectedStores));
      // 등록 페이지에 이동
      this.$router.push({name: 'admin-display-store-items-regist2'})
    },    
    forwardStoreItemDisplayDelete() {
      // 점포를 선택하지 않았을때
      if (this.selectedStores.length === 0) {        
        this.$parent.$parent.$parent.showErrorDialog(
          '店舗を選択してください'
        )
        return
      }

      // 선택한 점포를 sesseion에 등록
      sessionStorage.setItem("param", JSON.stringify(this.selectedStores));
      // 삭제 페이지에 이동
      this.$router.push({name: 'admin-display-store-items-delete2'})      
    },    
  },
  computed: {
    ...mapState({
      user: state => state.admin
    }),
    selectCategory: {
      get() {
        return this.$store.state.adminSession.selectCategory
      },
      set(value) {
        this.$store.commit('SET_SELECTED_ITEM_CATEGORY', value)
      }
    }
  },
  data() {
    return {
      loadingData: false,
      loader: null,
      dispDeleted: '',
      stores: [],
      suppliers: [],
      selectSupplier: {
        supplierCode: '#',
        supplierName: '全て(使える店舗)'
      },
      items: [],
      itemCategories: [],
      selectedStores: [],
      checkbox: null,
      headers: [
        {
          text: '選択',
          align: 'left',
          value: 'selectStore',
          width: '30px',
          sortable: false,
          fixed: true
        },
        {
          text: '店舗コード',
          align: 'left',
          value: 'storeCode',
          width: '50px',
          sortable: false,
          fixed: true
        },
        {
          text: '店舗名',
          align: 'left',
          sortable: false,
          value: 'storeName',
          width: '380px',
          fixed: true
        },
        {
          text: '取引先コード',
          align: 'left',
          sortable: false,
          value: 'supplierCode',
          width: '30px'
        }
      ]
    }
  }
}
</script>

<style>
.column-input {
  width: 100% !important;
  height: 30px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
}
.deleted-class-name {
  background-color: #b3b3b3;
}
tr.changed-class-name,
.theme--light.v-table
  tbody
  tr.changed-class-name:hover:not(.v-datatable__expand-row) {
  background-color: #ffcccc;
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>
